module.exports = __webpack_public_path__ + "img/icon3.96b939ff.svg";